// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  justify-content: space-between;
  height: 2rem;
  margin: 0.25rem 0.625rem;
  color: rgb(144.7432432432, 155.5, 166.2567567568);
}

p {
  margin: 0;
  line-height: 2rem;
}

.item-display {
  display: inline-block;
  line-height: 2rem;
  vertical-align: bottom;
}

.page-control {
  display: inline-block;
  text-align: right;
}
.page-control > * {
  vertical-align: middle;
}
.page-control i {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  width: 0.875rem;
  text-align: center;
}
.page-control i:hover:not(.disabled) {
  cursor: pointer;
  color: #456c9b;
}
.page-control i.disabled {
  color: #dee2e6;
}
.page-control p {
  display: inline-block;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.page-control p.page-number {
  display: none;
}
.page-control input {
  display: inline-block;
  width: 2.5rem;
  margin-right: 0.25rem;
}

@media screen and (max-width: 345px) {
  .page-control input {
    display: none;
  }
  .page-control p.page-page {
    display: none;
  }
  .page-control p.page-number {
    display: inline-block;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/paginator/paginator.component.scss","webpack://./src/assets/styles/variables.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,wBAAA;EACA,iDAAA;AAFF;;AAKA;EACE,SAAA;EACA,iBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,iBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,iBAAA;AAFF;AAIE;EACE,sBAAA;AAFJ;AAKE;EACE,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;AAHJ;AAKI;EACE,eAAA;EACA,cCnCM;ADgCZ;AAMI;EACE,cC5BK;ADwBX;AAQE;EACE,qBAAA;EACA,oBAAA;EACA,qBAAA;AANJ;AAQI;EACE,aAAA;AANN;AAUE;EACE,qBAAA;EACA,aAAA;EACA,qBAAA;AARJ;;AAYA;EACE;IACE,aAAA;EATF;EAYA;IACE,aAAA;EAVF;EAaA;IACE,qBAAA;EAXF;AACF","sourcesContent":["@import 'variables';\n@import 'functions';\n\n:host {\n  display: flex;\n  justify-content: space-between;\n  height: rem(32);\n  margin: rem(4) rem(10);\n  color: darken($gray-500, 10);\n}\n\np {\n  margin: 0;\n  line-height: rem(32);\n}\n\n.item-display {\n  display: inline-block;\n  line-height: rem(32);\n  vertical-align: bottom;\n}\n\n.page-control {\n  display: inline-block;\n  text-align: right;\n\n  & > * {\n    vertical-align: middle;\n  }\n\n  i {\n    margin-left: rem(4);\n    margin-right: rem(4);\n    width: rem(14);\n    text-align: center;\n\n    &:hover:not(.disabled) {\n      cursor: pointer;\n      color: $dark-blue;\n    }\n\n    &.disabled {\n      color: $gray-300;\n    }\n  }\n\n  p {\n    display: inline-block;\n    margin-left: rem(4);\n    margin-right: rem(4);\n\n    &.page-number {\n      display: none;\n    }\n  }\n\n  input {\n    display: inline-block;\n    width: rem(40);\n    margin-right: rem(4);\n  }\n}\n\n@media screen and (max-width: 345px) {\n  .page-control input {\n    display: none;\n  }\n\n  .page-control p.page-page {\n    display: none;\n  }\n\n  .page-control p.page-number {\n    display: inline-block;\n  }\n}\n","@import './functions.scss';\n\n$standard-blue: #54b0cb;\n$dark-blue: #456c9b;\n$green: #6fa163;\n$yellow: #f6af0b;\n$red: #e84e25;\n$min-contrast-ratio: 3;\n\n$enable-validation-icons: false;\n\n$white: #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-550: #8d959d;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black: #000 !default;\n\n$bg-color: #778899;\n$primary: $dark-blue;\n$secondary: $standard-blue;\n$body-color: $gray-600;\n$light: $gray-300;\n$text-muted: $gray-550;\n\n$h1-font-size: rem(28);\n$h2-font-size: rem(24);\n$h3-font-size: rem(19);\n\n$input-btn-padding-y: 0.1875rem;\n$input-btn-padding-x: 0.375rem;\n$input-color: $gray-600;\n$input-placeholder-color: $gray-500;\n\n$grid-gutter-width: 12px;\n$border-color: $gray-200;\n\n// table\n$table-cell-padding: 0.625rem;\n\n$banner-height: rem(60);\n\n@import '../../../node_modules/bootstrap/scss/_functions';\n@import '../../../node_modules/bootstrap/scss/_variables';\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
